import { render, staticRenderFns } from "./VehicleListItem.vue?vue&type=template&id=12cb3e30&scoped=true"
import script from "./VehicleListItem.vue?vue&type=script&lang=js"
export * from "./VehicleListItem.vue?vue&type=script&lang=js"
import style0 from "./VehicleListItem.vue?vue&type=style&index=0&id=12cb3e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb3e30",
  null
  
)

export default component.exports